export const DEFAULT_VARIANT_SCHEMA_VERSION = 'schema_v1.0.0';

export enum LaunchDarklyFeatureKeys {
  COMPANY_REVIEW_FORM_PROD = 'company-review-form-prod',
  COMPANY_REVIEW_FORM_EXPERIMENT_2 = 'company-review-form-experiment-2',
  COMPANY_REVIEW_FORM_EXPERIMENT_3 = 'company-review-form-experiment-3',
}

export const LAUNCH_DARKLY_FEATURE_FLAGS_MAP = {
  //* To configure the flag navigate to: https://app.launchdarkly.com/projects/candidate/flags/company-review-form-prod/targeting?env=production&env=staging&selected-env=production
  [LaunchDarklyFeatureKeys.COMPANY_REVIEW_FORM_PROD]: {
    key: LaunchDarklyFeatureKeys.COMPANY_REVIEW_FORM_PROD,
    values: ['1.0.0', '2.0.0'],
    description:
      'Company Review Form Prod-Env 1st experiment (Old Existing V1, Next Simplified V2).',
  },
  //* To configure the flag navigate to: https://app.launchdarkly.com/projects/candidate/flags/company-review-form-experiment-2/targeting?env=production&env=staging&selected-env=production
  [LaunchDarklyFeatureKeys.COMPANY_REVIEW_FORM_EXPERIMENT_2]: {
    key: LaunchDarklyFeatureKeys.COMPANY_REVIEW_FORM_EXPERIMENT_2,
    values: ['1.0.0', '3.0.0'],
    description:
      'Swap between the current form and experiment 2 which is a minimal input then multiple optional pages',
  },
  //* To configure the flag navigate to: https://app.launchdarkly.com/projects/candidate/flags/company-review-form-experiment-3/targeting?env=production&env=staging&selected-env=production
  [LaunchDarklyFeatureKeys.COMPANY_REVIEW_FORM_EXPERIMENT_3]: {
    key: LaunchDarklyFeatureKeys.COMPANY_REVIEW_FORM_EXPERIMENT_3,
    values: ['1.0.0', '4.0.0', '4.0.1'],
    description:
      'Swap between the current form and experiment 3 which is a extend from Experiment2 and add  My role page ',
  },
} as const satisfies Record<
  LaunchDarklyFeatureKeys,
  { key: LaunchDarklyFeatureKeys; values: string[]; description?: string }
>;
export type LaunchDarklyFeatureFlagMap = typeof LAUNCH_DARKLY_FEATURE_FLAGS_MAP;
